import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { GenericEntityProvider } from '../../components/genericEntity/context/genericEntityContext'
import { AdminPage } from '../../components/genericEntity/admin/AdminPage'
import { EntityPage } from '../../components/genericEntity/entity/EntityPage'

export default function GenericEntity(props) {
    // Processar permissões GenericEntity
    const roles = props.roles || [];
    
    // Verificar permissão de acesso ao Admin Config
    const canAdmin = roles.some(role => 
        role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('admin') && role.toLowerCase().includes('list')
    );
    
    // Verificar se é User (apenas visualização)
    const isUser = roles.some(role => 
        role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('user') && role.toLowerCase().includes('list')
    );
    
    // Admin tem acesso total, User tem apenas leitura
    const entityPermissions = {
        // Admin Entity permissions (configuração)
        canListEntities: canAdmin,
        canCreateEntity: canAdmin && roles.some(r => r.match(/GenericEntity Admin.*Create/i)),
        canEditEntity: canAdmin && roles.some(r => r.match(/GenericEntity Admin.*Edit/i)),
        canDeleteEntity: canAdmin && roles.some(r => r.match(/GenericEntity Admin.*Delete/i)),
        
        // Item permissions (Admin = tudo, User = apenas visualização)
        canListItems: canAdmin || isUser,
        canCreateItem: canAdmin, // User não pode criar
        canEditItem: canAdmin,   // User não pode editar
        canDeleteItem: canAdmin, // User não pode apagar
    };

    return (
        <GenericEntityProvider canAdmin={canAdmin} entityPermissions={entityPermissions}>
            <div className='baseLineSubmenus'>
                <Routes>
                    {/* Rota raiz removida - usuário acessa diretamente via menu lateral */}
                    {canAdmin && (
                        <Route path='admin' element={
                            <AdminPage 
                                onCreateTab={props.onCreateTab}
                                roles={props.roles}
                                toastMessages={props.toastMessages}
                            />
                        } />
                    )}
                    <Route path='entity/:entityId' element={
                        <EntityPage 
                            onCreateTab={props.onCreateTab}
                            roles={props.roles}
                            toastMessages={props.toastMessages}
                        />
                    } />
                </Routes>
            </div>
        </GenericEntityProvider>
    )
}
